import { IImportComponents } from '../_types/interfaces';


const importSecureFile = async (data: FormData): Promise<void> => {
    return console.log(data);
};

let status = 0;

const checkLicenseLoadStatus = async (): Promise<boolean> => {
    if(status == 0)
    {
        status = 1
        setTimeout(() => {status = 2}, 5000);
        return true;
    }
    if(status == 2)
    {
        status = 0;
        return false;
    }
    return true;
};


export const fakeImportService: IImportComponents = {
    importSecureFile,
    checkLicenseLoadStatus
};